const PORTRAIT_PRINT_STYLE_ID = "portrait-report-page-style";

export const printPortraitReport = () => {
  document.getElementById(PORTRAIT_PRINT_STYLE_ID)?.remove();

  const style = document.createElement("style");
  style.id = PORTRAIT_PRINT_STYLE_ID;
  style.media = "print";
  style.textContent = "@page { size: A4 portrait; margin: 10mm; }";
  document.head.appendChild(style);

  const cleanup = () => {
    style.remove();
    window.removeEventListener("afterprint", cleanup);
  };

  window.addEventListener("afterprint", cleanup);
  window.print();
};
